function yssdk(env) {
  if (!env) {
    console.warn("没有指定埋点环境，默认使用测试环境接口");
  }
  if (env === "production") {
    // console.log('pro');
    return require('./lib/index.js');
  }
  // console.log('test');
  return require('./lib/index.dev.js');
}

module.exports = yssdk;
